<template>

    <div class="dd-m-quiz__question" v-if="item">
        <card-question-type-1 v-if="item.type == 1" :item="item" :offline="offline"></card-question-type-1>

        <card-question-type-2 v-else-if="item.type == 2" 
        :stepAnswered="stepAnswered"
        :item="item" :offline="offline" :itemIndex="itemIndex"></card-question-type-2>

        <card-question-type-3 v-else-if="item.type == 3" :item="item" :offline="offline"></card-question-type-3>

        <div class="btn_wrpr">
            <a @click="prevStep" class="dd-m-button dd-m-button--auto dd-m-button--prev" v-if="showPrevBtn">
            	{{getTranslateString('Previous')}}
            </a>
            <a @click="nextStep" class="dd-m-button dd-m-button--auto dd-m-button--next" v-if="item.text !== 'Gender' && showNextBtn">
            	{{getTranslateString('Next')}}
            </a>
            <button type="submit" class="dd-m-button dd-m-button--auto dd-m-button--next" v-if="showSubmit">
                {{getTranslateString('Get Results')}}
            </button>
        </div>
    </div>

</template>
<script>
    import CardQuestionType1 from "./card-question-type-1";
    import CardQuestionType2 from "./card-question-type-2";
    import CardQuestionType3 from "./card-question-type-3";

    export default {
        name: 'card-question',
        components: {CardQuestionType3, CardQuestionType2, CardQuestionType1},
        props: ['item', 'itemIndex', 'offline', 'showNextBtn', 'showPrevBtn', 'showSubmit', 'stepAnswered'],
        data: () => {
            return {
                results: []
            }
        },
        mounted(){
        },

        methods: {
            nextStep(){
                this.$emit('localNextStep');
            },
            prevStep() {
                this.$emit('localPrevStep');
            }
        }
    }
</script>

<style>
    .dd-m-quiz__question .btn_wrpr {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
    }
    .dd-m-quiz__question .btn_wrpr .dd-m-button--prev {
        border-radius: 4px;
        color: #7f28c4;
        border: 3px solid #7f28c4;
        margin-right: 40px;
    }
    .dd-m-quiz__question .btn_wrpr .dd-m-button--prev:hover {
        background-color: #7f28c4;
        color: #fff; 
    }
    .dd-m-button--next {
        background-color: #000;
        border-radius: 4px;
        color: #fff; 
    }
</style>



// WEBPACK FOOTER //
// resources/site/js/components/quiz/card-question.vue